import { render, staticRenderFns } from "./PersonPhotos.vue?vue&type=template&id=255c614a&scoped=true&"
import script from "./PersonPhotos.vue?vue&type=script&lang=js&"
export * from "./PersonPhotos.vue?vue&type=script&lang=js&"
import style0 from "./PersonPhotos.vue?vue&type=style&index=0&id=255c614a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255c614a",
  null
  
)

export default component.exports